import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const EmployeesListTable = ({
  children,
  count,
  ///////
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  ///////
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('employees.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('employees.fields.name') + ': ' },
    { variable: 'lastname', text: t('employees.fields.lastname') + ': ' },
    { variable: 'email', text: t('employees.fields.email') + ': ' },
    { variable: 'position', text: t('employees.fields.position') + ': ' },
    {
      variable: 'active',
      text: t('employees.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.employees.update',
    togglePermission: 'acl.employees.toggle',
    editUrl: 'employees', //Url para editar empleado
    propsName: 'employee', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      {/* //////////////////// */}
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('employees.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('employees.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="lastname"
            handleOrderChange={handleOrderChange}
          >
            {t('employees.fields.lastname')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="email"
            handleOrderChange={handleOrderChange}
          >
            {t('employees.fields.email')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="position"
            handleOrderChange={handleOrderChange}
          >
            {t('employees.fields.position')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('employees.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(EmployeesListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/EmployeesListTable.js